var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('HomeHeader'),_c('HomeServices'),_c('HomeAbout'),_c('HomeExpertise'),_c('HomeContact'),_c('HomeClients')],1)}
var staticRenderFns = []

export { render, staticRenderFns }